import React from 'react'

const RoundingRules = () => {
    return (
        <>RoundingRules mobile</>
    )
}

export { RoundingRules }